<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Exibir Modelo
        </h1>
      </b-col>
    </div>
    <b-card>
      <b-row>
        <b-col xs="12" sm="12" md="8" lg="8" xl="8">
          <b-form-group label="Descrição:" label-for="descricao" class="text-label">
            <b-form-input
              id="descricao"
              name="descricao"
              v-model="minuta.descricao"
              type="text"
              maxlength="150"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Movimento:"
            label-for="movimento"
            class="text-label"
          >
            <b-form-select
              id="movimento"
              name="movimento"
              v-model="minuta.codMovimento"
              :value="minuta.codMovimento"
              :disabled="true"
            >
              <option selected :value="minuta.codMovimento">
                {{ minuta.descricaoMovimento }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Tipo Tramitação:"
            label-for="tipoTramitacao"
            class="text-label"
          >
            <b-form-select
              id="tipoTramitacao"
              name="tipoTramitacao"
              v-model="minuta.codTipoTramitacao"
              :value="minuta.codTipoTramitacao"
              :disabled="true"
            >
              <option selected :value="minuta.codTipoTramitacao">
                {{ minuta.textoTipoTramitacao }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-form-group
            label="Tipo de Documento:"
            label-for="tipoDocumento"
            class="text-label"
          >
            <b-form-select
              id="tipoDocumento"
              name="tipoDocumento"
              v-model="minuta.tipoDocumento"
              :value="minuta.tipoDocumento"
              :disabled="true"
            >
              <option
                v-for="tpDoc in listaTipoDocumento.options"
                :key="tpDoc.value"
                :value="tpDoc.value"
              >
                {{ tpDoc.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="2" lg="2" xl="2">
          <b-form-group
            label="Situação:"
            label-for="nome"
            class="text-label"
          >
            <b-form-radio-group
                id="radio-group-1"
                v-model="minuta.indAtivo"
                :options="situacao.options"
                :disabled="true"
              >
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
          <vue-editor
            id="editor"
            v-model="minuta.textoModelo"
            class="p-3"
            :disabled="true"
          >
          </vue-editor>
        </b-col>
      </b-row>

      <b-row>
        <b-col xs="12" sm="12" md="4" lg="4" xl="4">
          <b-button variant="primary" @click="voltar">
            <i class="fa fa-reply"></i> Voltar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import axios from "axios";

import formatarMixins from "../../../mixins/formatarMixins";
import { VueEditor } from "vue2-editor";
export default {
  name: "ManterMinutaEditar",
  mixins: [formatarMixins],
  components: {
    VueEditor,
  },
  data() {
    return {
      minuta: {
        descricao: null,
        movimento: null,
        tipoTramitacao: null,
        tipoDocumentoValor: null,
        textoModelo: null,
        indAtivo: true,
      },
      listaTipoDocumento:{
        options:[
          {value: null, text: "Selecione" },
          {value: 'APELACAO', text: "Apelação" },
          {value: 'CONTESTACAO', text: "Contestação" },
          {value: 'EMBARGOS', text: "Embargos de Declaração" },
          {value: 'PETICAO', text: "Petição Outras" },
        ]
      },
      situacao: {
        selected: "todos",
        options: [
          { text: "Ativo", value: true },
          { text: "Inativo", value: false },
        ],
      },
    };
  },
  methods: {
    voltar() {
      this.$store.commit("setMinuta", null);
      this.$router.push({ path: "/minuta" });
    },

    async obterMinuta(codMinuta) {
      const urlApi = process.env.VUE_APP_ROOT_API;
      const token = JSON.parse(this.$store.getters.getUser).access_token;

      await axios
        .post(`${urlApi}/v1/minuta/obter`, codMinuta, {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.minuta = response.data;
        })
        .catch((error) => {
          this.exibirErro(error);
        });
    },
  },
  mounted() {
    this.$store.commit("setMessages", {});

    const minutaEditada = this.$store.getters.getModeloMinuta;
    this.minuta = minutaEditada
    this.situacao.selected = this.minuta.indAtivo

  },
};
</script>

<style scoped></style>
